import { render } from "./Agenzie.vue?vue&type=template&id=7c25dd5c"
import script from "./Agenzie.vue?vue&type=script&lang=js"
export * from "./Agenzie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__